import { FC, useContext, useEffect, useState } from 'react';

import TicketsRefinement from '../TicketsRefinement/TicketsRefinement';
import { HeaderStyled } from './RefinementHeader.styled';
import ButtonIcon from 'components/ButtonIcon/ButtonIcon';
import { TicketsContext } from 'contexts/TicketsContext';
import { useUserProfile } from 'contexts/UserProfileContext';
import { TicketsRefinementKeysE } from 'declarations/enums/tickets';
import ColumnPickerIcon from 'icons/ColumnPickerIcon';

const RefinementHeader: FC = () => {
  const { getSearchParam } = useContext(TicketsContext);
  const { setColumnPickerPopupVisibility } = useUserProfile();

  const [isRoofTopFiltered, setIsRoofTopFiltered] = useState(false);

  useEffect(() => {
    setIsRoofTopFiltered(getSearchParam(TicketsRefinementKeysE.RoofTopId) !== null ? true : false);
  }, [getSearchParam, isRoofTopFiltered, setIsRoofTopFiltered]);
  const handleColumnPickerClick = () => {
    setColumnPickerPopupVisibility(true);
  };

  return (
    <HeaderStyled>
      <TicketsRefinement />
      <ButtonIcon
        title="Customize table columns"
        icon={<ColumnPickerIcon />}
        onClick={handleColumnPickerClick}
        className="column-picker"
      />
    </HeaderStyled>
  );
};

export default RefinementHeader;
